<script lang="ts">
	//Services
	import { format } from '../../../../services/i18n';
	//Components
	import ActionsContext from '../WebHooksHelpers/ActionsContext.svelte';
	//Constants
	import { SLEEPING_TYPES } from '../../../../constants';
	//Design system components
	import { Text } from '@Shelly/shelly-design-system';

	export let device;
	//just a wrapper that points to sensor inside actions context
</script>

{#if SLEEPING_TYPES.includes(device.type)}
	<Text class="mb-s">{$format('sleeping_apply_actions_description')}</Text>
{/if}
<ActionsContext {device} type={'sensor'} />
